import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import AlertFeed from "./components/AlertFeed";
import AlertDrawer from "./components/AlertDrawer";
import { useGetMultiDeviceParameters } from "../../queries/parameters";
import { useLocationStore } from "../../store/useLocationStore";
import { useDeviceStore } from "../../store/useDeviceStore";
import { useIsAdmin } from "../../utils/auth";

export default function AlertsPage() {
  const isAdmin = useIsAdmin();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const { selectedLocationId } = useLocationStore();
  const { selectedDeviceId, selectedDeviceIds } = useDeviceStore();
  // Check parameters across all selected devices — the alert form lets the
  // user target any device in the location, not just the primary selection.
  const paramFetchIds =
    selectedDeviceIds.length > 0
      ? selectedDeviceIds
      : selectedDeviceId
        ? [selectedDeviceId]
        : [];
  const { data: deviceParameters } = useGetMultiDeviceParameters(paramFetchIds);

  const hasParameters = deviceParameters && deviceParameters.length > 0;
  return (
    <div className="flex-1 flex flex-col ">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Alert Feed
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1 max-w-2xl">
            Define custom alerts to notify you when a device picks up
            specified pollutant levels, temperature ranges, or goes offline.
          </p>
        </div>

        {hasParameters && (
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              onClick={() => navigate("/alerts/manage")}
              className="flex items-center gap-2"
            >
              <Icon icon="heroicons:cog-6-tooth" className="w-4 h-4" />
              View Alerts
            </Button>
            {isAdmin && (
              <Button
                variant="outline"
                onClick={() => setIsDrawerOpen(true)}
                className="inline-flex items-center gap-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-medium text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                <PlusIcon className="w-4 h-4" />
                New Alert
              </Button>
            )}
          </div>
        )}
      </div>

      {/* Alert Feed */}
      <AlertFeed />

      {/* Alert Creation Drawer */}
      <AlertDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </div>
  );
}
